module.exports = {
    "frames": [
        {
            "time": 0,
            "image": require("@frog/source/assets/images/bomber-tactics/units/yellow/p-death-yellow/p-death-yellow1_.png").default
        },
        {
            "time": 100,
            "image": require("@frog/source/assets/images/bomber-tactics/units/yellow/p-death-yellow/p-death-yellow2_.png").default
        },
        {
            "time": 200,
            "image": require("@frog/source/assets/images/bomber-tactics/units/yellow/p-death-yellow/p-death-yellow3_.png").default
        },
        {
            "time": 300,
            "image": require("@frog/source/assets/images/bomber-tactics/units/yellow/p-death-yellow/p-death-yellow4_.png").default
        },
        {
            "time": 400,
            "image": require("@frog/source/assets/images/bomber-tactics/units/yellow/p-death-yellow/p-death-yellow5_.png").default
        },
        {
            "time": 500,
            "image": require("@frog/source/assets/images/bomber-tactics/units/yellow/p-death-yellow/p-death-yellow6_.png").default
        },
        {
            "time": 600,
            "image": require("@frog/source/assets/images/bomber-tactics/units/yellow/p-death-yellow/p-death-yellow7_.png").default
        },
        {
            "time": 700,
            "image": require("@frog/source/assets/images/bomber-tactics/units/yellow/p-death-yellow/p-death-yellow8_.png").default
        },
        {
            "time": 800,
            "image": require("@frog/source/assets/images/bomber-tactics/units/yellow/p-death-yellow/p-death-yellow9_.png").default
        },
        {
            "time": 900,
            "image": require("@frog/source/assets/images/bomber-tactics/units/yellow/p-death-yellow/p-death-yellow10_.png").default
        },
        {
            "time": 1000,
            "image": require("@frog/source/assets/images/bomber-tactics/units/yellow/p-death-yellow/p-death-yellow11_.png").default
        },
        {
            "time": 1100,
            "image": require("@frog/source/assets/images/bomber-tactics/units/empty_.png").default
        }
    ]
}
